<template>
    <v-row class="text-center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <div v-if="!authConfigLoaded" class="mt-8">
          {{msg}}
        </div>

        <v-card v-else-if="localEnabled" class="pa-4 mt-8">
          <v-card-title class="justify-center">账号登录</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="loginLocal">
              <v-text-field v-model="userid" label="用户名" autocomplete="username"
                            :disabled="submitting" autofocus></v-text-field>
              <v-text-field v-model="password" label="密码" type="password"
                            autocomplete="current-password" :disabled="submitting"></v-text-field>
              <v-alert v-if="errorMsg" type="error" dense>{{errorMsg}}</v-alert>
              <v-btn type="submit" color="primary" block :loading="submitting"
                     :disabled="submitting || !userid || !password">登录</v-btn>
            </v-form>
          </v-card-text>
        </v-card>

        <div v-else class="mt-8">
          {{msg}}
        </div>
      </v-col>
    </v-row>
</template>

<script>

  export default {
    name: 'UnAuthenticated',

    data: () => ({
      msg: '...登陆中，请稍等...',
      userid: '',
      password: '',
      submitting: false,
      errorMsg: ''
    }),
    computed: {
      authConfigLoaded() {
        return this.$store.state.authConfig !== null
      },
      localEnabled() {
        return this.$store.getters.localEnabled
      }
    },
    methods: {
      login: async function() {
        this.$store.dispatch('login').then(()=>{
          if (this.$store.state.cur_user) {
            this.msg = '...登录成功，待我跳转...'
            console.log(`welcome: ${this.$store.state.cur_user.name}`)
            this.$router.push('/')
          } else {
            this.msg = '您的账户未被授权，请重试或联系管理员。'
          }
        })
      },
      loginLocal: async function() {
        if (this.submitting || !this.userid || !this.password) return

        this.submitting = true
        this.errorMsg = ''

        try {
          await this.$store.dispatch('localLogin', {
            userid: this.userid.trim(),
            password: this.password
          })
          this.$router.push('/')
        } catch (e) {
          console.log(`local login error:${e.message}-${e.stack}`)
          this.errorMsg = (e.code === 401 || e.name === 'NotAuthenticated')
            ? '用户名或密码错误'
            : (e.message || '登录失败，请稍后重试')
          this.password = ''
        } finally {
          this.submitting = false
        }
      }
    },
    created() {
      this.$store.dispatch('loadAuthConfig').then((authConfig) => {
        if (!authConfig.localEnabled) {
          setTimeout(this.login, 0)
        }
      })
    }
  }
</script>
